import { jsx as _jsx } from "react/jsx-runtime";
export function Card({ children, className = "", ...rest }) {
    return _jsx("div", { className: `card ${className}`, ...rest, children: children });
}
export function CardHead({ ink = false, children, className = "", ...rest }) {
    const inkClass = ink ? "card__head--ink" : "card__head--plain";
    return _jsx("div", { className: `card__head ${inkClass} ${className}`, ...rest, children: children });
}
export function CardBody({ children, className = "", ...rest }) {
    return _jsx("div", { className: `card__body ${className}`, ...rest, children: children });
}
export function CardFoot({ children, className = "", ...rest }) {
    return _jsx("div", { className: `card__foot ${className}`, ...rest, children: children });
}
//# sourceMappingURL=Card.js.map